<template>
	<div class="box">
		<div class="row">
			<h3 class="col-8" >{{ $t('monte.congelation.liste_protocoles') }}</h3>
			<div class="col-4">
				<div class="row">
					<b-form-checkbox
						class="col-4"
						v-model="show_archives"
						@change="updateTableau"
					>
						{{ $t('tiers.archives') }}
					</b-form-checkbox>
					<b-form-checkbox
						class="col-8"
						v-model="show_actifs"
						@change="updateTableau"
					>
						{{ $t('tiers.actifs') }}
					</b-form-checkbox>
				</div>
			</div>
		</div>
		<p>{{ $t('monte.congelation.protocole_ordre_explication') }}</p>
		<div class="row pr-5 pl-2">
			<div class="col-6">{{ $t('monte.congelation.protocole_label') }}</div>
			<div class="col-3">{{ $t('monte.congelation.protocole_code') }}</div>
			<div class="col-1">{{ $t('monte.congelation.protocole_archiver') }}</div>
			<div class="text-right col-2">
				<b-button variant="primary" @click.prevent="openAddProtocole">{{ $t('global.ajouter') }} <font-awesome-icon :icon="['fal', 'plus']" /></b-button>
			</div>
		</div>
		<LoadingSpinner v-if="loading" />
		<draggable v-else class="list-group list-group-left" :list="protocoles_filtred" v-bind="dragOptions" group="colonne" @update="debouncedOrder">
			<div v-for="protocole in protocoles_filtred" class="list-group-item align-items-center" :key="protocole.protocole_id">
				<div class="form-row align-items-center">
					<div class="col-6">{{ protocole.protocole_label }}</div>
					<div class="col-3">{{ protocole.protocole_code }}</div>
					<div class="col-1">
						<font-awesome-icon class="text-success" v-if="protocole.protocole_archive" :icon="['fal', 'check-circle']" />
						<font-awesome-icon class="text-danger" v-else :icon="['fal', 'times-circle']" />
					</div>
					<div class="text-right col-2">
						<b-button variant="secondary" @click.prevent="openEditProtocole(protocole)">{{ $t('global.modifier') }} <font-awesome-icon :icon="['fal', 'angle-right']" /></b-button>
						<b-button variant="secondary" class="ml-auto order-md-last"><font-awesome-icon :icon="['fal', 'sort-alt']" /></b-button>
					</div>
			    </div>
			</div>
		</draggable>

		<b-modal ref="modal-protocole" hide-footer size="xl">
			<template v-if="!form.protocole_id" v-slot:modal-title>
				{{ $t('monte.congelation.add_protocole') }}
			</template>
			<template v-else v-slot:modal-title>
				{{ $t('monte.congelation.edit_protocole') }}
			</template>

			<div v-if="form_message !== ''" class="col-12 alert alert-danger">{{ form_message }}</div>

			<div class="row">
				<div class="col-6 form-group">
					<label for="protocole_label">{{ $t("monte.congelation.protocole_label") }} *</label>
					<b-input class="form-control" type="text" v-model="form.protocole_label" id="protocole_label" />
				</div>
				<div class="col-6 form-group">
					<label for="protocole_archive">{{ $t("monte.congelation.protocole_archiver") }}</label>
					<b-form-checkbox v-model="form.protocole_archive" id="protocole_archive" />
				</div>
				<div class="col-6 form-group">
					<label for="protocole_color" class="col-form-label">{{ $t("monte.congelation.protocole_color") }} *</label>
					<b-form-input type="color" id="protocole_color" v-model="form.protocole_color"></b-form-input>
				</div>
				<div class="col-6 form-group">
					<label for="protocole_color_police" class="col-form-label">{{ $t("monte.congelation.protocole_color_police") }} *</label>
					<b-form-input type="color" id="protocole_color_police" v-model="form.protocole_color_police"></b-form-input>
				</div>
				<div class="col-6 form-group">
					<label for="protocole_code">{{ $t("monte.congelation.protocole_code") }} *</label>
					<b-input class="form-control" type="text" v-model="form.protocole_code" id="protocole_code" />
				</div>
				<div class="col-6 form-group">
					<label for="protocole_start">{{ $t("monte.congelation.protocole_start") }}</label>
					<b-input class="form-control" type="number" v-model="form.protocole_start" id="protocole_start" />
				</div>
				<div class="col-6 form-group">
					<label for="protocole_before">{{ $t("monte.congelation.protocole_before") }}</label>
					<b-input class="form-control" type="number" v-model="form.protocole_before" id="protocole_before" />
				</div>
				<div class="col-6 form-group">
					<label for="protocole_after">{{ $t("monte.congelation.protocole_after") }}</label>
					<b-input class="form-control" type="number" v-model="form.protocole_after" id="protocole_after" />
				</div>
				<div class="col-12 form-group">
					<label>{{ $t('pax.dispo_pays_stallion') }}</label>
					<e-select
						track-by="id"
						label="name"
						:options="countries_iso_array"
						:searchable="true"
						:allow-empty="true"
						:show-labels="false"
						:multiple="true"
						:search="true"
						v-model="protocole_countries"
					>
						<template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
						<template slot="option" slot-scope="props">
							{{ props.option.name }}
						</template>
						<template slot="noOptions">{{ $t('global.list_empty') }}</template>
					</e-select>
				</div>
			</div>
			<div class="row">
				<div class="col">
					{{ $t('monte.congelation.protocoles') }}
				</div>
				<div class="col-auto ml-auto">
					<b-button @click.prevent="addNorme"><font-awesome-icon :icon="['fal', 'plus']" /></b-button>
				</div>
			</div>
			<div v-for="(norme, index) in protocole_normes" class="row mt-2 border py-2" :key="index">
				<div class="col-2">
					<label for="protocolenorme_label">{{ $t("monte.congelation.protocole_label") }} *</label>
				</div>
				<div class="col-9">
					<b-input class="form-control" type="text" v-model="norme.label" id="protocolenorme_label" />
				</div>
				<div class="col-1 text-right">
					<b-button @click.prevent="removeNorme(index)"><font-awesome-icon :icon="['fal', 'trash-alt']" /></b-button>
				</div>
				<div class="col-2 my-1">
					<label for="protocolenorme_description">{{ $t("monte.congelation.protocole_description") }} *</label>
				</div>
				<div class="col-10 my-1">
					<textarea class="form-control" type="text" v-model="norme.description" id="protocolenorme_description"></textarea>
				</div>
				<div class="col-12">
					<table class="table table-hover table-sm mb-0">
						<tr>
							<td>{{ $t('monte.congelation.acte_type') }}</td>
							<td>{{ $t('monte.congelation.delay') }}</td>
							<td class="text-right"><b-button @click.prevent="addActeType(norme)"><font-awesome-icon :icon="['fal', 'plus']" /></b-button></td>
						</tr>
						<tr v-for="(acte_type, index_actes) in norme.actes_types" :key="index_actes">
							<td>
								<div class="row">
									<div class="col-12">
										<e-select
											v-model="acte_type.acte_type"
											id="actestype_id"
											track-by="actestype_id"
											label="actestype_label"
											:placeholder="$t('acte.selectionnez_acte')"
											:selectedLabel="$t('global.selected_label')"
											:options="actes_types"
											:searchable="true"
											:allow-empty="false"
											:show-labels="false"
											:group-select="false"
										>
											<template slot="noOptions">{{ $t('global.list_empty') }}</template>
										</e-select>
									</div>
								</div>
								<div v-if="acte_type.acte_type && acte_type.acte_type.has_labo" class="row">
									<div class="col-4">
										<e-select
											v-model="acte_type.labo"
											id="code"
											track-by="code"
											label="name"
											:placeholder="$t('acte.selectionnez_labo')"
											:selectedLabel="$t('global.selected_label')"
											:options="all_laboratoires"
											:searchable="true"
											:show-labels="false"
											:group-select="false"
										>
											<template slot="noOptions">{{ $t('global.list_empty') }}</template>
										</e-select>
									</div>
									<div class="col-4">
										<e-select
											v-model="acte_type.matrice"
											id="code"
											track-by="code"
											label="name"
											:placeholder="$t('acte.selectionnez_matrice')"
											:selectedLabel="$t('global.selected_label')"
											:options="all_matrices[acte_type.acte_type.actestype_code]"
											:searchable="true"
											:show-labels="false"
											:group-select="false"
											multiple
										>
											<template slot="noOptions">{{ $t('global.list_empty') }}</template>
										</e-select>
									</div>
									<div class="col-4">
										<e-select
											v-model="acte_type.analyse"
											:placeholder="$t('acte.selectionnez_analyse')"
											:selectedLabel="$t('global.selected_label')"
											:options="all_analyses[acte_type.acte_type.actestype_code]"
											:searchable="true"
											:show-labels="false"
											:group-select="false"
											multiple
										>
											<template slot="noOptions">{{ $t('global.list_empty') }}</template>
										</e-select>
									</div>
								</div>
							</td>
							<td><b-input class="form-control" type="number" v-model="acte_type.delay" /></td>
							<td class="text-right">
								<b-button @click.prevent="duplicateActeType(norme, acte_type)"><font-awesome-icon :icon="['far', 'clone']" /></b-button>
								<b-button @click.prevent="removeActeType(norme, index_actes)"><font-awesome-icon :icon="['fal', 'trash-alt']" /></b-button>
							</td>
						</tr>
					</table>
				</div>
			</div>

			<div class="text-center">
				<a class="btn btn-primary mt-3" href="#" @click.prevent="checkForm">{{ $t('global.enregistrer') }} <font-awesome-icon v-if="processing" :icon="['fal', 'spinner']" pulse /><font-awesome-icon v-else :icon="['fal', 'save']" /></a>
			</div>
		</b-modal>
	</div>
</template>

<script type="text/javascript">
	import Congelation from "@/mixins/Congelation.js"
    import draggable from 'vuedraggable'
    import _debounce from 'lodash/debounce'
	import _cloneDeep from 'lodash/cloneDeep'
	import Vue from 'vue'
	import Countries from '@/assets/lang/countries/countries'

	export default {
		name: 'Protocoles',
		mixins: [Congelation],
		data () {
			return {
				loading: false,
				protocoles: [],
				show_archives: true,
    			show_actifs: true,
				protocoles_filtred:[],
				protocole_normes: [],
				actes_types: [],
				processing: false,
				form: {
					protocole_id: null,
					protocole_label: '',
					protocole_color: '#fff',
					protocole_color_police: '#000',
					protocole_code: '',
					protocole_start: 0,
					protocole_before: 0,
					protocole_after: 0,
					protocole_archive: false,
					protocole_order: 999
				},
                dragOptions: {
                    animation: 200
                },
                debouncedOrder: _debounce(this.updateOrder, 500),
				form_message: '',
				countries_iso_array: [],
				protocole_countries: [],
				all_laboratoires: [],
				all_matrices: [],
				all_analyses: []
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.loading = true

				const countries = Countries[Vue.i18n.locale()].label
				const countries_iso = Countries[Vue.i18n.locale()].iso_3

				let countries_values = Object.values(countries)
				let countries_iso_values = Object.values(countries_iso)

				let temp = []
				for (let i = 0; i < countries_values.length; i++) {
					temp.push(countries_values[i]+' - '+countries_iso_values[i])
				}

				let countries_iso_array_temp = []
				let countries_keys = Object.keys(countries)
				let countries_formatted = Object.fromEntries(countries_keys.map((_, i) => [countries_keys[i], temp[i]]))
				for (let [key, value] of Object.entries(countries_formatted)) {
					countries_iso_array_temp.push({
						id: key,
						name: value
					})
				}
				this.countries_iso_array = countries_iso_array_temp.sort((a,b) => {
					// return a.name - b.name;
					var x = this.accentsTidy(a.name.toLowerCase());
				    var y = this.accentsTidy(b.name.toLowerCase());
				    return x < y ? -1 : x > y ? 1 : 0;
				});

				this.protocoles = await this.getAllProtocoles()
				this.actes_types = await this.getActeTypeTest()
				this.all_laboratoires = await this.getAllLaboratoire()
				this.updateTableau()

				const matrices_mec = await this.getMatriceByActeType('TEST_NEW2_MTRITE_CONTAGIEUSE_QUINE_MEC_POUR_TALON')
				const matrices_ave = await this.getMatriceByActeType('TEST_NEW2_ARTRITE_VIRALE_QUINE_EVA_POUR_TALON')
				const matrices_aie = await this.getMatriceByActeType('TEST_NEW2_ANMIE_INFCTIEUSE_DES_EQUIDS_AIE')
				this.all_matrices = {
					'TEST_NEW2_MTRITE_CONTAGIEUSE_QUINE_MEC_POUR_TALON': matrices_mec,
					'TEST_NEW2_ARTRITE_VIRALE_QUINE_EVA_POUR_TALON': matrices_ave,
					'TEST_NEW2_ANMIE_INFCTIEUSE_DES_EQUIDS_AIE': matrices_aie
				}

				const analyses_mec = await this.getAnalyseByActeType('TEST_NEW2_MTRITE_CONTAGIEUSE_QUINE_MEC_POUR_TALON')
				const analyses_ave = await this.getAnalyseByActeType('TEST_NEW2_ARTRITE_VIRALE_QUINE_EVA_POUR_TALON')
				const analyses_aie = await this.getAnalyseByActeType('TEST_NEW2_ANMIE_INFCTIEUSE_DES_EQUIDS_AIE')
				this.all_analyses = {
					'TEST_NEW2_MTRITE_CONTAGIEUSE_QUINE_MEC_POUR_TALON': analyses_mec,
					'TEST_NEW2_ARTRITE_VIRALE_QUINE_EVA_POUR_TALON': analyses_ave,
					'TEST_NEW2_ANMIE_INFCTIEUSE_DES_EQUIDS_AIE': analyses_aie
				}

				this.loading = false
			},

			openAddProtocole() {
				this.form = {
					protocole_id: null,
					protocole_label: '',
					protocole_color: '#fff',
					protocole_color_police: '#000',
					protocole_code: '',
					protocole_start: 0,
					protocole_before: 0,
					protocole_after: 0,
					protocole_archive: false
				}
				this.protocole_normes = []
				this.$refs['modal-protocole'].show()
			},

			openEditProtocole(protocole) {
				this.form = protocole

				this.protocole_normes = protocole.normes.map(n => {
					const actes_types = n.actes_types.map(a => {
						const acte_type = this.actes_types.find(type => type.actestype_id == a.protocoleactetype_actetype)
						const labo = a.protocoleactetype_laboratoire ? this.all_laboratoires.find(l => l.code == a.protocoleactetype_laboratoire) : ''
						const matrice = a.protocoleactetype_matrice ? this.all_matrices[acte_type.actestype_code].filter(m => a.protocoleactetype_matrice.includes(m.code)) : []
						const analyse = a.protocoleactetype_analyse ? this.all_analyses[acte_type.actestype_code].filter(n => a.protocoleactetype_analyse.includes(n)) : []

						return {
							acte_type,
							delay: a.protocoleactetype_delay,
							labo,
							matrice,
							analyse
						}
					})

					return {
						id: n.protocolenorme_id,
						label: n.protocolenorme_label,
						description: n.protocolenorme_description,
						actes_types
					}
				})

				const countries_ids = protocole.protocole_countries ? protocole.protocole_countries.split(',') : []
				this.protocole_countries = this.countries_iso_array.filter(c => countries_ids.includes(c.id))

				this.$refs['modal-protocole'].show()
			},

			addNorme() {
				this.protocole_normes.push({
					id: 0,
					label: '',
					description: '',
					actes_types: []
				})
			},

			addActeType(norme) {
				const index = this.protocole_normes.findIndex(n => n == norme)
				this.protocole_normes[index].actes_types.push({
					acte_type: null,
					delay: 0
				})
			},

			removeNorme(index) {
				this.protocole_normes.splice(index, 1)
			},

			removeActeType(norme, index_acte) {
				const index = this.protocole_normes.findIndex(n => n == norme)
				this.protocole_normes[index].actes_types.splice(index_acte, 1)
			},

			duplicateActeType(norme, acte_type) {
				const index = this.protocole_normes.findIndex(n => n == norme)
				this.protocole_normes[index].actes_types.push(_cloneDeep(acte_type))
			},

			async checkForm() {
				this.form_message = ''
				this.processing = true

				if(this.form.protocole_code == '') {
					this.form_message = this.getTrad("monte.congelation.protocole_code_vide")
					this.processing = false
					return false
				}

				if(this.form.protocole_label == '') {
					this.form_message = this.getTrad("monte.congelation.protocole_label_vide")
					this.processing = false
					return false
				}

				const normes = this.protocole_normes.map(n => ({
					id: n.id,
					label: n.label,
					description: n.description,
					actes_types: n.actes_types.map(a => ({
						acte_type: a.acte_type.actestype_id,
						delay: a.delay,
						labo: a.labo ? a.labo.code : '',
						matrice: a.matrice ? a.matrice.map(l => l.code).join(',') : '',
						analyse: a.analyse ? a.analyse.join(',') : ''
					}))
				}))

				const countries_ids = this.protocole_countries.map(c => c.id).join(',')
				if(this.form.protocole_id) {
					await this.editProtocole(this.form.protocole_id, this.form, normes, countries_ids)
				}
				else {
					await this.createProtocole(this.form, normes, countries_ids)
				}
				this.processing = false
				this.$refs['modal-protocole'].hide()
				this.init_component()
			},

			async updateOrder() {
				const orders = {}
				this.protocoles_filtred.forEach((protocole, index) => {
					orders[index] = protocole.protocole_id
				})
				await this.saveProtocoleOrder(orders)
				this.successToast('toast.info_save_succes')
			},
			async updateTableau() {
				this.$nextTick(()=> {
					this.protocoles_filtred = this.protocoles.filter( p => (this.show_archives && p.protocole_archive) || (this.show_actifs && !p.protocole_archive))
				})
			},
		},
		components: {
            LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
            draggable 
		}
	}

</script>